import queryClient from '../query-client';
import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import { PostResponseBody } from '../types/api-response';
import { FYIConfig } from '../types/fyi-docs';

export type CreateFYIConfigRequest = {
    accessKeyId: string;
    accessKeySecret: string;
};

async function createFYIConfig(req: CreateFYIConfigRequest): Promise<PostResponseBody<FYIConfig>> {
    const { data } = await api.post('/fyi-docs/configuration', req);
    return data;
}

export function useCreateFYIConfig(): UseMutationResult<PostResponseBody<FYIConfig>, AxiosError, CreateFYIConfigRequest, unknown> {
    return useMutation(createFYIConfig, {
        onSettled: () => {
            queryClient.invalidateQueries(['fyi', 'configuration']);
            queryClient.invalidateQueries(['firm']);
        },
    });
}
